export default "__VITE_PUBLIC_ASSET__9f39f7f8__"